import { jsxs, jsx } from 'react/jsx-runtime';
import { useResourceDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { styled } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { DESKTOP_CARD_HEIGHT } from '@fabric-app/ui/theme/resourcePreviewConstants';
import { renderResourceIcon } from '../../../../../resource-detail/components/ResourceIcon/renderResourceIcon.js';
import { getResourceNamePlaceholder } from '../../../../utils/getResourceTitle.js';
import MemberBar from '../../../../../multiplayer/components/MemberBar/MemberBar.js';
import NoteStack from '../../../NoteStack/NoteStack.js';
import { useRef } from 'react';
import { useDomContentRect } from '@fabric-app/hooks/useDomContentRect';
import { useBoolState } from '@fabric-app/hooks/useBooleanState';
import { containerPreviewCompact } from '../cssPreviewContainer.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { cssLineClamp, mediaNotMobile } from '@fabric-app/ui/constants/styled-utils';

const memberList = [];
const ResourcePreviewInnerFolder = () => {
  const { resource } = useResourceDataContextSafe();
  const containerRef = useRef(null);
  const [rect] = useDomContentRect(containerRef);
  const notestackHoveredState = useBoolState();
  const scale = rect ? rect.width / 650 : 0;
  const { isMobileView } = useResponsive();
  const hoverProps = isMobileView ? void 0 : {
    onMouseOver: notestackHoveredState.handleTrue,
    onMouseLeave: notestackHoveredState.handleFalse
  };
  return /* @__PURE__ */ jsxs(Container, {
    ref: containerRef,
    ...hoverProps,
    "data-preview-content-wrapper": "folder",
    children: [
      /* @__PURE__ */ jsx(IconContainer, {
        children: renderResourceIcon(resource, {
          size: 30
        })
      }),
      /* @__PURE__ */ jsx(Title, {
        children: resource.name || getResourceNamePlaceholder(resource)
      }),
      /* @__PURE__ */ jsx(MemberBar, {
        partialMembersList: memberList,
        spaceOverviewViewMode: "Grid",
        hideWhenAlone: true,
        maxMembers: 3,
        avatarSize: 24,
        hideWrappingContainer: true,
        itemType: "space",
        isPublicShared: resource.isShared || resource.isDirectShared
      }),
      resource.descendants && scale ? /* @__PURE__ */ jsx(NoteStackWrapper, {
        children: /* @__PURE__ */ jsx(NoteStack, {
          noTilt: true,
          isHoveredView: notestackHoveredState.value,
          // @ts-expect-error - incomplete object but still fine
          resources: resource.descendants,
          noteStackViewMode: "Grid",
          maxNotes: 3,
          scale,
          verticalSpread: scale < 0.3 ? 0.4 : 1,
          avatarSize: 24,
          hideWrappingContainer: true
        })
      }) : null
    ]
  });
};
const Container = styled.div.withConfig({
  displayName: "ResourcePreviewInnerFolder__Container",
  componentId: "sc-924067f1-0"
})([
  `border:2px solid `,
  `;border-radius:var(--preview-content-border-radius,1.125rem);height:`,
  `px;padding:1.5rem;display:flex;flex-direction:column;align-items:center;gap:0.75rem;overflow:hidden;background-color:`,
  `;`,
  `{align-items:flex-start;padding:0.75rem;gap:0.5rem;border:none;}`
], cssVar["color-border-secondary"], DESKTOP_CARD_HEIGHT - 30, cssVar["color-bg-primary"], containerPreviewCompact);
const IconContainer = styled.div.withConfig({
  displayName: "ResourcePreviewInnerFolder__IconContainer",
  componentId: "sc-924067f1-1"
})([
  `display:flex;align-items:center;justify-content:center;height:30px;width:30px;font-size:26px;flex-shrink:0;`
]);
const Title = styled.div.withConfig({
  displayName: "ResourcePreviewInnerFolder__Title",
  componentId: "sc-924067f1-2"
})([
  `font-size:0.875rem;font-weight:600;letter-spacing:-2%;color:rgba(var(--fabric-color-text-secondary-rgb),0.7);`,
  ` `,
  `{text-align:center;}`
], cssLineClamp(2), mediaNotMobile);
const NoteStackWrapper = styled.div.withConfig({
  displayName: "ResourcePreviewInnerFolder__NoteStackWrapper",
  componentId: "sc-924067f1-3"
})([
  `flex-grow:1;display:flex;align-items:center;justify-content:center;width:100%;`
]);

export { ResourcePreviewInnerFolder };
//# sourceMappingURL=ResourcePreviewInnerFolder.js.map
